import { render, staticRenderFns } from "./article-footer.vue?vue&type=template&id=15f42446&scoped=true"
import script from "./article-footer.vue?vue&type=script&lang=js"
export * from "./article-footer.vue?vue&type=script&lang=js"
import style0 from "./article-footer.vue?vue&type=style&index=0&id=15f42446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f42446",
  null
  
)

export default component.exports